/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Corrective_Exercise_TermsInputs */

const en_service_type_corrective_exercise_terms = /** @type {(inputs: Service_Type_Corrective_Exercise_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`posture, scoliosis, flat feet, postural correction`)
};

const pl_service_type_corrective_exercise_terms = /** @type {(inputs: Service_Type_Corrective_Exercise_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wady postawy, postawa, skolioza, garbienie, płaskostopie, korekcja`)
};

/**
* | output |
* | --- |
* | "posture, scoliosis, flat feet, postural correction" |
*
* @param {Service_Type_Corrective_Exercise_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_corrective_exercise_terms = /** @type {((inputs?: Service_Type_Corrective_Exercise_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Corrective_Exercise_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_corrective_exercise_terms(inputs)
	return en_service_type_corrective_exercise_terms(inputs)
});